import styles from './CTROverlay.module.css';

/**
 * CRT visual effects overlay
 * Adds scanlines, noise grain, and flicker effect
 */
export function CTROverlay() {
  return <div className={styles.overlay} />;
}
